import "./styles/main.css"
import { SvgIcons, Login, Board } from "./components"
import { useEffect, useState } from "react"

const code = new URLSearchParams(window.location.search).get("code")

function App() {
  const rootElement = document.body;

  // Vérifie si l'API Fullscreen est disponible dans le navigateur
  if (rootElement.requestFullscreen) {
    // Appelle la méthode requestFullscreen() pour passer en mode plein écran
    rootElement.requestFullscreen();
  } else if (rootElement.mozRequestFullScreen) { // Pour Firefox
    rootElement.mozRequestFullScreen();
  } else if (rootElement.webkitRequestFullscreen) { // Pour Chrome, Safari et Opera
    rootElement.webkitRequestFullscreen();
  } else if (rootElement.msRequestFullscreen) { // Pour Edge
    rootElement.msRequestFullscreen();
  }

  const [width, setWidth] = useState(window.innerWidth);

  const handleWindowSizeChange = () => setWidth(window.innerWidth);
  
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  const isMobile = width <= 768;

  return (
    <>
      {isMobile &&
        <div className="App">
          <SvgIcons/>
          {code ? <Board code={code} /> : <Login />}
        </div>
      }
      {!isMobile &&
        <div className="App">
          <SvgIcons />
          <div className="login">
            <div className="login-header" >
              <img src='assets/cosmox-bubble.png' alt='Avatar'/>
            </div>
            <h1>Cosmox est disponible uniquement sur tablette et mobile</h1>
            <div className='blur1'></div>
            <div className='blur2'></div>
            <div className='blur3'></div>
          </div>
        </div>
      }
    </>
  );
}

export default App;
